import ShopList from 'views/web/shop/ShopList';
import { NextPageWithLayout } from 'pages/_app';
import { MediaQueryContext } from 'libs/contexts';
import ShopListMobile from 'views/ShopList';
import { useContext } from 'react';
export { getServerSideProps } from 'libs/shop/getServerSideProps';
import { ProductListNetPriceContextProvider } from 'libs/contexts';

const ShopListPage: NextPageWithLayout = (props: any) => {
  const { isMobile } = useContext(MediaQueryContext);
  return (
    <ProductListNetPriceContextProvider>
      {isMobile ? <ShopListMobile /> : <ShopList {...props} />}
    </ProductListNetPriceContextProvider>
  );
};

ShopListPage.layoutProps = {
  title: '店铺列表',
};
export default ShopListPage;
